import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
export default defineComponent({
    name: 'breadcrumb-nav',
    components: {},
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), mapGetters('global', {
        isMobile: 'isMobile',
    })),
});
